import React, { useEffect, useRef } from "react";

export default function BaseModal({ show, onClose, title, children, footerButtons }) {
  const modalRef = useRef(null);

  // useEffect(() => {
  //   if (show) {
  //     const modal = new window.bootstrap.Modal(modalRef.current);
  //     modal.show();

  //     modalRef.current.addEventListener("hidden.bs.modal", onClose);
  //     return () => {
  //       modalRef.current.removeEventListener("hidden.bs.modal", onClose);
  //     };
  //   }
  // }, [show, onClose]);


  useEffect(() => {
    const modalEl = modalRef.current;
  
    if (!modalEl) return;
  
    const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
  
    if (show) {
      modal.show();
      modalEl.addEventListener("hidden.bs.modal", onClose);
    } else {
      modal.hide();
      modalEl.removeEventListener("hidden.bs.modal", onClose);
    }
  
    // Cleanup when unmounting or `show` changes
    return () => {
      modalEl.removeEventListener("hidden.bs.modal", onClose);
    };
  }, [show, onClose]);
  

  return (
    <div
      className="modal fade"
      ref={modalRef}
      tabIndex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-fullscreen-lg-down">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <div className="modal-body">{children}</div>

          <div className="modal-footer">
            {footerButtons?.map((btn, idx) => (
              <button
                key={idx}
                type={btn.type || "button"}
                className={`btn ${btn.className || "btn-primary"}`}
                onClick={btn.onClick}
                data-bs-dismiss={btn.dismiss ? "modal" : undefined}
              >
                {btn.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
